import { render, staticRenderFns } from "./Settings_Targetings.vue?vue&type=template&id=8bb0215c&scoped=true"
import script from "./Settings_Targetings.vue?vue&type=script&lang=js"
export * from "./Settings_Targetings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb0215c",
  null
  
)

export default component.exports